module.exports = __webpack_public_path__ + "img/shofar_no.0ce87971.png";